var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxReversedChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 28,
  height: 28,
  rx: 8,
  fill: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  transform: "translate(-9.5,-6)",
  d: "M31.4114 14.2354L21.2202 24.4265L16.5879 19.7942",
  stroke: "#2715FF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgCheckboxReversedChecked as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiByeD0iOCIgZmlsbD0id2hpdGUiLz4KPHBhdGggdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkuNSwtNikiCiAgICAgIGQ9Ik0zMS40MTE0IDE0LjIzNTRMMjEuMjIwMiAyNC40MjY1TDE2LjU4NzkgMTkuNzk0MiIKICAgICAgc3Ryb2tlPSIjMjcxNUZGIgogICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";